import React from "react";
import { Box, Typography } from "@mui/material";
import type { BarChartConfig } from "@store/slices/chart-config-slice";
import LoadingSpinner from "@components/common/LoadingSpinner";
import EmptyChartState from "@components/common/EmptyChartState";
import GroupedBarChart from "../../GroupedBarChart";

interface GroupedBarPreviewPanelProps {
  currentConfig: BarChartConfig;
  isRefetchingData: boolean;
  isAvailableData: boolean;
}

const GroupedBarPreviewPanel: React.FC<GroupedBarPreviewPanelProps> = ({
  currentConfig,
  isRefetchingData,
  isAvailableData,
}) => {
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        p: 3,
      }}
    >
      <Typography variant="h6" sx={{ mb: 2 }}>
        Preview
      </Typography>
      <Box
        sx={{
          flex: 1,
          border: 1,
          borderColor: "divider",
          borderRadius: 1,
          minHeight: 400,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
        }}
      >
        {isRefetchingData ? (
          <LoadingSpinner message="Loading data..." />
        ) : isAvailableData ? (
          <EmptyChartState message="This question has no response data available for visualization" />
        ) : (
          <GroupedBarChart config={currentConfig} />
        )}
      </Box>

      <Box
        sx={{
          mt: 2,
          p: 1,
          px: 2.5,
          backgroundColor: "#f9fafb",
          borderRadius: 1,
          borderTop: "1px solid #e0e0e0",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Typography variant="caption" color="text.secondary" fontWeight={500}>
          Weight:{" "}
          {currentConfig.weight === "DISABLED" ? "No Weight" : "Default Weight"}
        </Typography>
      </Box>
    </Box>
  );
};

export default GroupedBarPreviewPanel;
